export class Student {
    constructor(studentId: number, firstName: string, middleName: string, lastName: string) {
        this.id = studentId;
        this.firstName = firstName;
        this.middleName = middleName;
        this.lastName = lastName;
    }

    public id: number = 0;
    public firstName: string;
    public middleName: string;
    public lastName: string;

    public getFullName(): string {
        return this.firstName + ' ' + (this.middleName ? this.middleName + ' ' : '') + this.lastName;
    }
}
